<template></template>

<script>
export default {
    name: "CreateInvoice",
    methods: {
        init() {
            const invoiceForm = this.$showPanel({
                component: 'invoice-form',
                openOn: 'right',
                cssClass: 'sidePanel',
                width: 1024,
            })
            invoiceForm.promise.then(result => {
                this.$emit('reload-overview-cards');

                if(result.child) {
                    this.$notify({type: 'success', text: trans('general.billing.new_invoice_added')})
                }
            })
        }
    },
}
</script>
